
  export default {
    name: 'internship',
    props: ['internshipData'],
  };
